// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CrmUtils from "../../../../../../../../../library/CrmUtils.bs.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CrmRouteManager from "../../../../../../../to-be-migrated/routing/CrmRouteManager.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as ViewUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FooterActions$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/FooterActions.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as SuspensionInfoViewMapper from "../../../../vm-mapper/driver-records/SuspensionInfoViewMapper.bs.js";
import * as TerminationInfoViewMapper from "../../../../vm-mapper/driver-records/TerminationInfoViewMapper.bs.js";
import * as SectionHeaderComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/section-header/SectionHeaderComponent.bs.js";

function getSuspensionInfoActions(msisdn, driverUuid, adminId, adminEmail, suspensionInfo, workspace_dispatch, toggleModal) {
  var suspensionInfoData = ViewUtils$Catalyst.extractLiveData(suspensionInfo);
  var actions = suspensionInfoData !== undefined && List.length(suspensionInfoData.suspension_history) >= 1 ? ({
        hd: CrmUtils.getViewMoreButtonProps((function (param) {
                return Curry._2(workspace_dispatch.addTab, {
                            TAG: /* DriverSuspensionList */6,
                            _0: msisdn
                          }, false);
              }), CrmRouteManager.getRouteFromTab({
                  TAG: /* DriverSuspensionList */6,
                  _0: msisdn
                }), undefined, undefined),
        tl: /* [] */0
      }) : /* [] */0;
  var tmp;
  switch (suspensionInfo.TAG | 0) {
    case /* Live */1 :
        var match = suspensionInfo._0.suspend_status;
        tmp = match ? ({
              hd: ButtonUtils$Catalyst.getDefaultButtonProps({
                    TAG: /* Text */0,
                    _0: "Suspend"
                  }, undefined, (function (param) {
                      return Curry._1(toggleModal, {
                                  TAG: /* Suspend */0,
                                  _0: msisdn
                                });
                    }), /* Secondary */1, undefined, undefined, undefined, undefined, undefined, undefined),
              tl: /* [] */0
            }) : ({
              hd: ButtonUtils$Catalyst.getDefaultButtonProps({
                    TAG: /* Text */0,
                    _0: "Unsuspend"
                  }, undefined, (function (param) {
                      return Curry._1(toggleModal, {
                                  TAG: /* Unsuspend */1,
                                  _0: {
                                    msisdn: msisdn,
                                    driverUuid: driverUuid,
                                    adminId: adminId,
                                    adminEmail: adminEmail
                                  }
                                });
                    }), /* Secondary */1, undefined, undefined, undefined, undefined, undefined, undefined),
              tl: /* [] */0
            });
        break;
    case /* Loading */0 :
    case /* Error */2 :
        tmp = /* [] */0;
        break;
    
  }
  return List.append(actions, tmp);
}

function getTerminationInfoActions(msisdn, terminationInfo, workspace_dispatch, toggleModal) {
  var terminationInfoData = ViewUtils$Catalyst.extractLiveData(terminationInfo);
  var actions = terminationInfoData !== undefined && List.length(terminationInfoData.driverTerminationHistory) >= 1 ? ({
        hd: CrmUtils.getViewMoreButtonProps((function (param) {
                return Curry._2(workspace_dispatch.addTab, {
                            TAG: /* DriverTerminationList */7,
                            _0: msisdn
                          }, false);
              }), CrmRouteManager.getRouteFromTab({
                  TAG: /* DriverTerminationList */7,
                  _0: msisdn
                }), undefined, undefined),
        tl: /* [] */0
      }) : /* [] */0;
  var tmp;
  switch (terminationInfo.TAG | 0) {
    case /* Live */1 :
        var match = terminationInfo._0.activeStatus;
        tmp = match !== 1 ? ({
              hd: ButtonUtils$Catalyst.getDefaultButtonProps({
                    TAG: /* Text */0,
                    _0: "Terminate"
                  }, undefined, (function (param) {
                      return Curry._1(toggleModal, {
                                  TAG: /* Termination */2,
                                  _0: msisdn
                                });
                    }), /* Secondary */1, undefined, undefined, undefined, undefined, undefined, undefined),
              tl: /* [] */0
            }) : /* [] */0;
        break;
    case /* Loading */0 :
    case /* Error */2 :
        tmp = /* [] */0;
        break;
    
  }
  return List.append(actions, tmp);
}

function getAccordionPanels(msisdn, driverUuid, adminId, adminEmail, suspensionInfo, terminationInfo, workspace_dispatch, toggleModal) {
  return {
          hd: AccordionTypes$Catalyst.make_props({
                TAG: /* Text */0,
                _0: "Suspension Info"
              }, Caml_option.some(React.createElement(FooterActions$Catalyst.make, {
                        actions: getSuspensionInfoActions(msisdn, driverUuid, adminId, adminEmail, suspensionInfo, workspace_dispatch, toggleModal)
                      })), undefined, SuspensionInfoViewMapper.getView(suspensionInfo), undefined),
          tl: {
            hd: AccordionTypes$Catalyst.make_props({
                  TAG: /* Text */0,
                  _0: "Termination Info"
                }, Caml_option.some(React.createElement(FooterActions$Catalyst.make, {
                          actions: getTerminationInfoActions(msisdn, terminationInfo, workspace_dispatch, toggleModal)
                        })), undefined, TerminationInfoViewMapper.getView(terminationInfo), undefined),
            tl: /* [] */0
          }
        };
}

function PunishmentInfoSection(Props) {
  var msisdn = Props.msisdn;
  var driverUuid = Props.driverUuid;
  var adminId = Props.adminId;
  var adminEmail = Props.adminEmail;
  var suspensionInfo = Props.suspensionInfo;
  var terminationInfo = Props.terminationInfo;
  var workspace_dispatch = Props.workspace_dispatch;
  var toggleModal = Props.toggleModal;
  return React.createElement("div", {
              className: "section-container"
            }, React.createElement(SectionHeaderComponent$Catalyst.make, {
                  heading: "Punishment Info"
                }), React.createElement(Accordion$Catalyst.make, {
                  panels: getAccordionPanels(msisdn, driverUuid, adminId, adminEmail, suspensionInfo, terminationInfo, workspace_dispatch, toggleModal),
                  className: "accordion-container"
                }));
}

var make = PunishmentInfoSection;

export {
  getSuspensionInfoActions ,
  getTerminationInfoActions ,
  getAccordionPanels ,
  make ,
  
}
/* react Not a pure module */
